import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography
} from '@mui/material';
import { Fragment, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  defaultContent,
  paths,
  upgradePlanModalTexts,
  upgradePlanWarnContent,
  upgradePlanWarnContentFree
} from 'src/common/config/TextMessage';
import CommonModal from 'src/common/config/CommonModal';
import { useLocation, useNavigate } from 'react-router';
import DeactivateModal from 'src/content/applications/Users/settings/DeactivateModal';
import {
  handleInterComClick,
  isAiAddonLocked,
  localStorageMethod
} from './config/FunctionHelper';
import { setIsOpenChangePlan } from 'src/redux/siteAuditReducer';
import { upgradeWarningPlanSx } from './CommomSxs';
import { AvatarGroupModule } from './AvatarGroupsModule';
import { viewScanDialogSx } from './ViewScanDialogSxs';
import CloseIcon from '@mui/icons-material/Close';
import { RootState } from 'src/redux/store';
// In this component we up-grading plan and delete a scan that's previously been done
const UpgradeWarningPlan = ({ isFreePlan = false }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [openDeleteSiteModal, setDeleteSiteModal] = useState(true);
  const [openDeactivateModal, setOpenDeactivateModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const pathKey = location.pathname.split('/').pop(); // Extract the last part of the path
  let activePlanName = useSelector((state: RootState) => state.user.activePlan);
  let planDetails = useSelector((state: RootState) => state.user.planDetails);
  const isEnterprise = activePlanName === planDetails?.enterprise;
  const isNotUnlocked = isAiAddonLocked();

  // Handle conformation box
  const handleCloseDeleteSiteModal = () => {
    setDeleteSiteModal(false);
    navigate(isNotUnlocked ? paths?.externalScans : paths?.dashboard);
  };

  // Handel cancel subscription model close event
  const handleMonitorWebModalClose = () => {
    setOpenDeactivateModal(false);
  };

  const content = upgradePlanWarnContent[pathKey] || defaultContent;

  // Conformation box HTML
  const showFunction = () => {
    return (
      <Fragment>
        <div style={upgradeWarningPlanSx?.mainCardBoxSx}>
          <Box className="flex justify-between items-center">
            <Typography sx={upgradeWarningPlanSx?.titleSx}>
              {isFreePlan ? upgradePlanWarnContentFree?.title : content.title}
            </Typography>
            <IconButton
              aria-label="delete"
              style={viewScanDialogSx?.closeIconBtnSx}
              className="hover:rounded-lg"
              onClick={handleCloseDeleteSiteModal}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Typography sx={upgradeWarningPlanSx?.subHeader}>
            {isFreePlan
              ? upgradePlanWarnContentFree?.subHeader
              : content.subHeader}
          </Typography>
          <Box sx={upgradeWarningPlanSx?.listBox}>
            <List>
              {content.featureList.map((feature, index) => (
                <ListItem key={index} sx={upgradeWarningPlanSx?.listItem}>
                  <ListItemIcon sx={upgradeWarningPlanSx?.listItemIcon}>
                    <img
                      draggable={false}
                      src={
                        process.env.PUBLIC_URL +
                        `/static/images/icons/blue_check.svg`
                      }
                      alt="Check Icon"
                    />
                  </ListItemIcon>
                  <ListItemText
                    sx={upgradeWarningPlanSx?.listItemText}
                    primary={feature}
                  />
                </ListItem>
              ))}
            </List>
          </Box>
          <Box sx={upgradeWarningPlanSx?.avatarBox}>
            <Typography sx={upgradeWarningPlanSx?.joinWith}>
              {upgradePlanModalTexts?.joinWithText}
            </Typography>
            <AvatarGroupModule />
          </Box>
          <div className="flex space-x-5  mt-5 justify-center h-10 mb-4">
            <Button
              variant="contained"
              // size="medium"
              sx={upgradeWarningPlanSx?.btnSx}
              disabled={loading}
              onClick={() => {
                if (isEnterprise) {
                  handleInterComClick();
                } else {
                  setLoading(true);
                  localStorageMethod('set', 'isSignUp', 'true');
                  dispatch(setIsOpenChangePlan(true));
                  navigate(paths?.billing);
                }
              }}
            >
              {' '}
              {loading ? (
                <CircularProgress size={24} />
              ) : isEnterprise ? (
                upgradePlanModalTexts?.contactUs
              ) : (
                upgradePlanModalTexts?.upgradePlan
              )}
            </Button>
          </div>
        </div>
      </Fragment>
    );
  };

  return (
    <>
      {showFunction()}
      {/** Subscription cancel modal  */}
      <CommonModal
        open={openDeactivateModal}
        handCloseModal={handleMonitorWebModalClose}
        title={''}
        closebtn={false}
        isAgencyModal={true}
        isInfoModal={true}
        isFreeDowngrade={true}
      >
        <DeactivateModal handCloseModal={handleMonitorWebModalClose} />
      </CommonModal>
    </>
  );
};

export default UpgradeWarningPlan;
